import { render, staticRenderFns } from "./carousselDashboard.vue?vue&type=template&id=e791700a"
import script from "./carousselDashboard.vue?vue&type=script&lang=js"
export * from "./carousselDashboard.vue?vue&type=script&lang=js"
import style0 from "./carousselDashboard.vue?vue&type=style&index=0&id=e791700a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports